import { gql } from "@apollo/client";
import Avatar from "atoms/Avatar";
import { getStatColor } from "helpers/colors";
import { ONSEN_ENV } from "helpers/environment";
import REACTION_TYPES from "helpers/REACTION_TYPES";
import React from "react";

export const EventMarkerFragment = gql`
  fragment EventMarkerFragment on Event {
    humanName
    singleCharacter
    reactionType
    made
  }
`;

export default function EventMarker({ event, size = 16, active = false, inverse = false, ...others }) {
  let eventColor = getStatColor(event?.humanName);
  let eventChar = event?.singleCharacter;
  let imgSrc = null;

  if (event?.reactionType) {
    imgSrc = REACTION_TYPES.find((r) => r.name === event?.reactionType)?.imgSrc || REACTION_TYPES[0]?.imgSrc;
    if (ONSEN_ENV === "test" && !imgSrc) throw new Error(`Unexpected reactionType: ${event?.reactionType}`);
  }

  return (
    <Avatar
      inverse={inverse}
      active={active}
      size={size}
      text={eventChar}
      color={eventColor}
      imgSrc={imgSrc}
      {...others}
    />
  );
}
